module.exports = __webpack_public_path__ + "img/certificate_bg_new.a49ddc1e.jpg";